// Extracted from body .babylon file
// 3 mesh(es), 3 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const BODY_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "03___Default",
    albedoColor: [0.00000000, 0.04710000, 0.29409999],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.00000000, 0.00000000, 0.00000000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const BODY_MESH_0: RuneMesh = {
  name: "Body_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64289999, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.68349999, 0.43309999, 0.06739997,
    0.68349999, 0.43309999, 0.06739997,
    0.68349999, 0.43309999, 0.06739997,
    0.72090000, 0.43309999, -0.07190003,
    0.72090000, 0.43309999, -0.07190003,
    0.48310000, 0.43309999, -0.06850003,
    0.48310000, 0.43309999, -0.06850003,
    0.43889999, 0.43309999, 0.06739997,
    0.43889999, 0.43309999, 0.06739997,
    0.43889999, 0.43309999, 0.06739997,
    0.43889999, 0.43309999, 0.06739997,
    0.72589999, 0.43310001, 0.32319996,
    0.64289999, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.39140001, 0.43310001, 0.58369994,
    0.39140001, 0.43310001, 0.58369994,
    0.53410000, 0.43310001, 0.44109997,
    0.53410000, 0.43310001, 0.44109997,
    0.53410000, 0.43310001, 0.44109997,
    0.34720001, 0.43310001, 0.29839998,
    0.34720001, 0.43310001, 0.29839998,
    0.34720001, 0.43310001, 0.29839998,
    0.29629999, 0.43310001, 0.34259996,
    0.29629999, 0.43310001, 0.34259996,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    0.07890000, 0.43310004, 0.72979993,
    0.07890000, 0.43310004, 0.72979993,
    0.07890000, 0.43310004, 0.72979993,
    0.02450000, 0.43310001, 0.52939993,
    0.02450000, 0.43310001, 0.52939993,
    0.02450000, 0.43310001, 0.52939993,
    0.12480000, 0.43310001, 0.43889996,
    0.12480000, 0.43310001, 0.43889996,
    0.20980000, 0.43309999, 0.07209997,
    0.20980000, 0.43309999, 0.07209997,
    0.34220001, 0.43309999, 0.07889997,
    0.34220001, 0.43309999, 0.07889997,
    0.39660001, 0.43309999, -0.06720003,
    0.39660001, 0.43309999, -0.06720003,
    0.39140001, 0.43309996, -0.31300002,
    0.39140001, 0.43309996, -0.31300002,
    0.39140001, 0.43309996, -0.31300002,
    0.57819998, 0.43309996, -0.48970002,
    0.57819998, 0.43309996, -0.48970002,
    0.57819998, 0.43309996, -0.48970002,
    0.43550000, 0.43309996, -0.58480006,
    0.43550000, 0.43309996, -0.58480006,
    0.43550000, 0.43309996, -0.58480006,
    0.34720001, 0.43309996, -0.39120004,
    0.34720001, 0.43309996, -0.39120004,
    0.16900000, 0.43309996, -0.39330003,
    0.16900000, 0.43309996, -0.39330003,
    0.07890000, 0.43309996, -0.47610003,
    0.07890000, 0.43309996, -0.47610003,
    0.07890000, 0.43309996, -0.47610003,
    0.10610000, 0.43309993, -0.67310005,
    0.10610000, 0.43309993, -0.67310005,
    -0.07740000, 0.43309993, -0.72740006,
    -0.07740000, 0.43309993, -0.72740006,
    -0.07740000, 0.43309993, -0.72740006,
    -0.02640000, 0.43309996, -0.52700007,
    -0.02640000, 0.43309996, -0.52700007,
    -0.02640000, 0.43309996, -0.52700007,
    -0.12650000, 0.43309996, -0.44760004,
    -0.12650000, 0.43309996, -0.44760004,
    -0.34729999, 0.43309999, -0.11810003,
    -0.34729999, 0.43309999, -0.11810003,
    -0.34909999, 0.43309996, -0.34360003,
    -0.34909999, 0.43309996, -0.34360003,
    -0.34909999, 0.43309996, -0.34360003,
    -0.30500001, 0.43309996, -0.43530002,
    -0.30500001, 0.43309996, -0.43530002,
    -0.30500001, 0.43309996, -0.43530002,
    -0.39330000, 0.43309993, -0.62210006,
    -0.39330000, 0.43309993, -0.62210006,
    -0.39330000, 0.43309993, -0.62210006,
    -0.54269999, 0.43309996, -0.53380007,
    -0.54269999, 0.43309996, -0.53380007,
    -0.54269999, 0.43309996, -0.53380007,
    -0.39829999, 0.43309999, 0.02789997,
    -0.39829999, 0.43309999, 0.02789997,
    -0.25220001, 0.43309999, 0.02449997,
    -0.25220001, 0.43309999, 0.02449997,
    -0.16390000, 0.43310001, 0.39479998,
    -0.16390000, 0.43310001, 0.39479998,
    -0.06720000, 0.43310001, 0.48859996,
    -0.06720000, 0.43310001, 0.48859996,
    -0.12490000, 0.43310004, 0.67539996,
    -0.12490000, 0.43310004, 0.67539996,
    -0.08310000, 0.43310004, 0.79029995,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.43740001, 0.43310001, 0.54299992,
    -0.43740001, 0.43310001, 0.54299992,
    -0.34230000, 0.43310001, 0.29839998,
    -0.34230000, 0.43310001, 0.29839998,
    -0.34230000, 0.43310001, 0.29839998,
    -0.40009999, 0.43310001, 0.26099998,
    -0.40009999, 0.43310001, 0.26099998,
    -0.40009999, 0.43310001, 0.26099998,
    -0.58350003, 0.43310001, 0.39689997,
    -0.58350003, 0.43310001, 0.39689997,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.72960001, 0.43309999, 0.02329997,
    -0.72960001, 0.43309999, 0.02329997,
    -0.72960001, 0.43309999, 0.02329997,
    -0.48840001, 0.43309999, 0.01989997,
    -0.48840001, 0.43309999, 0.01989997,
    -0.48840001, 0.43309999, 0.01989997,
    -0.43740001, 0.43309999, -0.11940003,
    -0.43740001, 0.43309999, -0.11940003,
    -0.43740001, 0.43309999, -0.11940003,
    -0.68879998, 0.43309999, -0.11940003,
    -0.68879998, 0.43309999, -0.11940003,
    -0.68879998, 0.43309999, -0.11940003,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91280001, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30419999, 0.24339992, -0.93610001,
    0.30419999, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30419999, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30419999, 0.18959993, -0.93610001,
    0.30419999, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91280001, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64289999, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64289999, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79030001,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
    -0.34909999, 0.35019997, -0.34360003,
    -0.34909999, 0.35019997, -0.34360003,
    -0.30500001, 0.35019997, -0.43530002,
    -0.30500001, 0.35019997, -0.43530002,
    -0.39330000, 0.35019994, -0.62210000,
    -0.39330000, 0.35019994, -0.62210000,
    -0.54269999, 0.35019997, -0.53380001,
    -0.54269999, 0.35019997, -0.53380001,
    -0.07740000, 0.35019994, -0.72740000,
    -0.07740000, 0.35019994, -0.72740000,
    -0.02640000, 0.35019997, -0.52700001,
    -0.02640000, 0.35019997, -0.52700001,
    0.07890000, 0.35019997, -0.47610003,
    0.10610000, 0.35019994, -0.67309999,
    0.39140001, 0.35019997, -0.31300002,
    0.57819998, 0.35019997, -0.48970002,
    0.57819998, 0.35019997, -0.48970002,
    0.43550000, 0.35019997, -0.58480000,
    0.43550000, 0.35019997, -0.58480000,
    0.34720001, 0.35019997, -0.39120004,
    0.43889999, 0.35020000, 0.06739997,
    0.43889999, 0.35020000, 0.06739997,
    0.68349999, 0.35020000, 0.06739997,
    0.68349999, 0.35020000, 0.06739997,
    0.72090000, 0.35020000, -0.07190003,
    0.48310000, 0.35020000, -0.06850003,
    0.39140001, 0.35020003, 0.58370000,
    0.53410000, 0.35020003, 0.44109997,
    0.53410000, 0.35020003, 0.44109997,
    0.34720001, 0.35020003, 0.29839998,
    0.34720001, 0.35020003, 0.29839998,
    0.29629999, 0.35020003, 0.34259996,
    0.07890000, 0.35020006, 0.72979999,
    0.07890000, 0.35020006, 0.72979999,
    0.02450000, 0.35020003, 0.52939999,
    0.02450000, 0.35020003, 0.52939999,
    -0.06720000, 0.35020003, 0.48859996,
    -0.12490000, 0.35020006, 0.67540002,
    -0.43740001, 0.35020003, 0.54299998,
    -0.34230000, 0.35020003, 0.29839998,
    -0.34230000, 0.35020003, 0.29839998,
    -0.40009999, 0.35020003, 0.26099998,
    -0.40009999, 0.35020003, 0.26099998,
    -0.58350003, 0.35020003, 0.39689997,
    -0.43740001, 0.35020000, -0.11940003,
    -0.43740001, 0.35020000, -0.11940003,
    -0.68879998, 0.35020000, -0.11940003,
    -0.68879998, 0.35020000, -0.11940003,
    -0.72960001, 0.35020000, 0.02329997,
    -0.72960001, 0.35020000, 0.02329997,
    -0.48840001, 0.35020000, 0.01989997,
    -0.48840001, 0.35020000, 0.01989997,
    0.39660001, 0.35020000, -0.06720003,
    0.16900000, 0.35019997, -0.39330003,
    0.16900000, 0.35019997, -0.39330003,
    -0.12650000, 0.35019997, -0.44760004,
    -0.25220001, 0.35020000, 0.02449997,
    -0.39829999, 0.35020000, 0.02789997,
    -0.34729999, 0.35020000, -0.11810003,
    0.34220001, 0.35020000, 0.07889997,
    0.20980000, 0.35020000, 0.07209997,
    0.12480000, 0.35020003, 0.43889996,
    0.12480000, 0.35020003, 0.43889996,
    -0.16390000, 0.35020003, 0.39479998,
    -0.03140000, 0.35020003, 0.30989996,
    0.11130000, 0.35020000, 0.07209997,
    0.20640001, 0.35020000, -0.02980003,
    0.30149999, 0.35020000, -0.01960003,
    0.07390000, 0.35019997, -0.30160004,
    -0.02460000, 0.35019997, -0.34570003,
    -0.25220001, 0.35020000, -0.06720003,
    -0.25220001, 0.35020000, -0.06720003,
    -0.15369999, 0.35020000, -0.07060003,
    -0.16050000, 0.35020000, 0.02109997,
    -0.16050000, 0.43309999, 0.02109997,
    -0.16050000, 0.43309999, 0.02109997,
    -0.03140000, 0.43310001, 0.30989996,
    -0.03140000, 0.43310001, 0.30989996,
    -0.03140000, 0.43310001, 0.30989996,
    -0.15369999, 0.43309999, -0.07060003,
    -0.15369999, 0.43309999, -0.07060003,
    -0.25220001, 0.43309999, -0.06720003,
    -0.25220001, 0.43309999, -0.06720003,
    -0.25220001, 0.43309999, -0.06720003,
    -0.02460000, 0.43309996, -0.34570003,
    -0.02460000, 0.43309996, -0.34570003,
    0.07390000, 0.43309996, -0.30160004,
    0.07390000, 0.43309996, -0.30160004,
    0.30149999, 0.43309999, -0.01960003,
    0.30149999, 0.43309999, -0.01960003,
    0.20640001, 0.43309999, -0.02980003,
    0.20640001, 0.43309999, -0.02980003,
    0.11130000, 0.43309999, 0.07209997,
    0.11130000, 0.43309999, 0.07209997,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 774, 759, 756, 761, 764, 766,
    774, 756, 761, 768, 770, 772, 772, 774, 761, 761, 766, 768,
    761, 768, 772, 126, 139, 1, 126, 1, 0, 1, 140, 141,
    1, 141, 2, 3, 2, 142, 3, 142, 4, 4, 142, 143,
    4, 143, 5, 5, 143, 144, 5, 144, 6, 6, 144, 145,
    6, 145, 7, 7, 145, 146, 7, 146, 8, 8, 146, 147,
    8, 147, 9, 9, 147, 148, 9, 148, 10, 10, 148, 149,
    10, 149, 11, 11, 149, 150, 11, 150, 12, 12, 150, 151,
    12, 151, 13, 13, 151, 152, 13, 152, 14, 14, 152, 153,
    14, 153, 15, 15, 153, 154, 15, 154, 16, 16, 154, 155,
    16, 155, 17, 17, 155, 156, 17, 156, 18, 18, 156, 157,
    18, 157, 30, 30, 157, 158, 30, 158, 31, 31, 158, 159,
    31, 159, 32, 32, 159, 160, 32, 160, 33, 33, 160, 161,
    33, 161, 44, 44, 161, 162, 44, 162, 45, 45, 162, 163,
    45, 163, 110, 110, 163, 164, 110, 164, 111, 111, 164, 165,
    111, 165, 112, 112, 165, 166, 112, 166, 113, 113, 166, 167,
    113, 167, 124, 124, 167, 168, 124, 168, 125, 125, 168, 139,
    125, 139, 126, 139, 169, 140, 139, 140, 1, 140, 170, 171,
    140, 171, 141, 2, 141, 172, 2, 172, 142, 142, 172, 173,
    142, 173, 143, 143, 173, 174, 143, 174, 144, 144, 174, 175,
    144, 175, 145, 145, 175, 176, 145, 176, 146, 146, 176, 177,
    146, 177, 147, 147, 177, 178, 147, 178, 148, 148, 178, 179,
    148, 179, 149, 149, 179, 180, 149, 180, 150, 150, 180, 181,
    150, 181, 151, 151, 181, 182, 151, 182, 152, 152, 182, 183,
    152, 183, 153, 153, 183, 184, 153, 184, 154, 154, 184, 185,
    154, 185, 155, 155, 185, 186, 155, 186, 156, 156, 186, 187,
    156, 187, 157, 157, 187, 188, 157, 188, 158, 158, 188, 189,
    158, 189, 159, 159, 189, 190, 159, 190, 160, 160, 190, 191,
    160, 191, 161, 161, 191, 192, 161, 192, 162, 162, 192, 193,
    162, 193, 163, 163, 193, 194, 163, 194, 164, 164, 194, 195,
    164, 195, 165, 165, 195, 196, 165, 196, 166, 166, 196, 197,
    166, 197, 167, 167, 197, 198, 167, 198, 168, 168, 198, 169,
    168, 169, 139, 169, 199, 170, 169, 170, 140, 170, 200, 201,
    170, 201, 171, 141, 171, 202, 141, 202, 172, 172, 202, 203,
    172, 203, 173, 173, 203, 204, 173, 204, 174, 174, 204, 205,
    174, 205, 175, 175, 205, 206, 175, 206, 176, 176, 206, 207,
    176, 207, 177, 177, 207, 208, 177, 208, 178, 178, 208, 209,
    178, 209, 179, 179, 209, 210, 179, 210, 180, 180, 210, 211,
    180, 211, 181, 181, 211, 212, 181, 212, 182, 182, 212, 213,
    182, 213, 183, 183, 213, 214, 183, 214, 184, 184, 214, 215,
    184, 215, 185, 185, 215, 216, 185, 216, 186, 186, 216, 217,
    186, 217, 187, 187, 217, 218, 187, 218, 188, 188, 218, 219,
    188, 219, 189, 189, 219, 220, 189, 220, 190, 190, 220, 221,
    190, 221, 191, 191, 221, 222, 191, 222, 192, 192, 222, 223,
    192, 223, 193, 193, 223, 224, 193, 224, 194, 194, 224, 225,
    194, 225, 195, 195, 225, 226, 195, 226, 196, 196, 226, 227,
    196, 227, 197, 197, 227, 228, 197, 228, 198, 198, 228, 199,
    198, 199, 169, 199, 229, 200, 199, 200, 170, 200, 230, 231,
    200, 231, 201, 171, 201, 232, 171, 232, 202, 202, 232, 233,
    202, 233, 203, 203, 233, 234, 203, 234, 204, 204, 234, 235,
    204, 235, 205, 205, 235, 236, 205, 236, 206, 206, 236, 237,
    206, 237, 207, 207, 237, 238, 207, 238, 208, 208, 238, 239,
    208, 239, 209, 209, 239, 240, 209, 240, 210, 210, 240, 241,
    210, 241, 211, 211, 241, 242, 211, 242, 212, 212, 242, 243,
    212, 243, 213, 213, 243, 244, 213, 244, 214, 214, 244, 245,
    214, 245, 215, 215, 245, 246, 215, 246, 216, 216, 246, 247,
    216, 247, 217, 217, 247, 248, 217, 248, 218, 218, 248, 249,
    218, 249, 219, 219, 249, 250, 219, 250, 220, 220, 250, 251,
    220, 251, 221, 221, 251, 252, 221, 252, 222, 222, 252, 253,
    222, 253, 223, 223, 253, 254, 223, 254, 224, 224, 254, 255,
    224, 255, 225, 225, 255, 256, 225, 256, 226, 226, 256, 257,
    226, 257, 227, 227, 257, 258, 227, 258, 228, 228, 258, 229,
    228, 229, 199, 229, 259, 230, 229, 230, 200, 230, 260, 261,
    230, 261, 231, 201, 231, 262, 201, 262, 232, 232, 262, 263,
    232, 263, 233, 233, 263, 264, 233, 264, 234, 234, 264, 265,
    234, 265, 235, 235, 265, 266, 235, 266, 236, 236, 266, 267,
    236, 267, 237, 237, 267, 268, 237, 268, 238, 238, 268, 269,
    238, 269, 239, 239, 269, 270, 239, 270, 240, 240, 270, 271,
    240, 271, 241, 241, 271, 272, 241, 272, 242, 242, 272, 273,
    242, 273, 243, 243, 273, 274, 243, 274, 244, 244, 274, 275,
    244, 275, 245, 245, 275, 276, 245, 276, 246, 246, 276, 277,
    246, 277, 247, 247, 277, 278, 247, 278, 248, 248, 278, 279,
    248, 279, 249, 249, 279, 280, 249, 280, 250, 250, 280, 281,
    250, 281, 251, 251, 281, 282, 251, 282, 252, 252, 282, 283,
    252, 283, 253, 253, 283, 284, 253, 284, 254, 254, 284, 285,
    254, 285, 255, 255, 285, 286, 255, 286, 256, 256, 286, 287,
    256, 287, 257, 257, 287, 288, 257, 288, 258, 258, 288, 259,
    258, 259, 229, 259, 289, 260, 259, 260, 230, 260, 292, 294,
    260, 294, 261, 231, 261, 295, 231, 295, 262, 262, 295, 296,
    262, 296, 263, 263, 296, 297, 263, 297, 264, 264, 297, 298,
    264, 298, 265, 265, 298, 299, 265, 299, 266, 266, 299, 300,
    266, 300, 267, 267, 300, 301, 267, 301, 268, 268, 301, 302,
    268, 302, 269, 269, 302, 303, 269, 303, 270, 270, 303, 304,
    270, 304, 271, 271, 304, 305, 271, 305, 272, 272, 305, 306,
    272, 306, 273, 273, 306, 307, 273, 307, 274, 274, 307, 308,
    274, 308, 275, 275, 308, 309, 275, 309, 276, 276, 309, 310,
    276, 310, 277, 277, 310, 311, 277, 311, 278, 278, 311, 312,
    278, 312, 279, 279, 312, 313, 279, 313, 280, 280, 313, 314,
    280, 314, 281, 281, 314, 315, 281, 315, 282, 282, 315, 316,
    282, 316, 283, 283, 316, 317, 283, 317, 284, 284, 317, 318,
    284, 318, 285, 285, 318, 319, 285, 319, 286, 286, 319, 320,
    286, 320, 287, 287, 320, 321, 287, 321, 288, 288, 321, 289,
    288, 289, 259, 289, 323, 292, 289, 292, 260, 290, 324, 326,
    290, 326, 293, 261, 294, 328, 261, 328, 295, 295, 328, 330,
    295, 330, 296, 296, 330, 332, 296, 332, 297, 297, 332, 334,
    297, 334, 298, 298, 334, 336, 298, 336, 299, 299, 336, 338,
    299, 338, 300, 300, 338, 340, 300, 340, 301, 301, 340, 342,
    301, 342, 302, 302, 342, 343, 302, 343, 303, 303, 343, 345,
    303, 345, 304, 304, 345, 347, 304, 347, 305, 305, 347, 349,
    305, 349, 306, 306, 349, 351, 306, 351, 307, 307, 351, 353,
    307, 353, 308, 308, 353, 355, 308, 355, 309, 309, 355, 357,
    309, 357, 310, 310, 357, 359, 310, 359, 311, 311, 359, 361,
    311, 361, 312, 312, 361, 363, 312, 363, 313, 313, 363, 365,
    313, 365, 314, 314, 365, 367, 314, 367, 315, 315, 367, 369,
    315, 369, 316, 316, 369, 371, 316, 371, 317, 317, 371, 373,
    317, 373, 318, 318, 373, 375, 318, 375, 319, 319, 375, 378,
    319, 378, 320, 320, 378, 380, 320, 380, 321, 321, 380, 323,
    321, 323, 289, 322, 381, 325, 322, 325, 291, 324, 382, 385,
    324, 385, 326, 293, 326, 387, 293, 387, 327, 327, 387, 388,
    327, 388, 329, 329, 388, 389, 329, 389, 331, 331, 389, 390,
    331, 390, 333, 333, 390, 391, 333, 391, 335, 335, 391, 392,
    335, 392, 337, 337, 392, 393, 337, 393, 339, 339, 393, 394,
    339, 394, 341, 341, 394, 395, 341, 395, 344, 344, 395, 396,
    344, 396, 346, 346, 396, 397, 346, 397, 348, 348, 397, 398,
    348, 398, 350, 350, 398, 399, 350, 399, 352, 352, 399, 400,
    352, 400, 354, 354, 400, 401, 354, 401, 356, 356, 401, 402,
    356, 402, 358, 358, 402, 403, 358, 403, 360, 360, 403, 404,
    360, 404, 362, 362, 404, 405, 362, 405, 364, 364, 405, 406,
    364, 406, 366, 366, 406, 407, 366, 407, 368, 368, 407, 408,
    368, 408, 370, 370, 408, 409, 370, 409, 372, 372, 409, 410,
    372, 410, 374, 374, 410, 411, 374, 411, 376, 376, 411, 412,
    376, 412, 377, 377, 412, 413, 377, 413, 379, 379, 413, 381,
    379, 381, 322, 381, 414, 384, 381, 384, 325, 383, 416, 417,
    383, 417, 386, 326, 385, 418, 326, 418, 387, 387, 418, 420,
    387, 420, 388, 388, 420, 422, 388, 422, 389, 389, 422, 424,
    389, 424, 390, 390, 424, 426, 390, 426, 391, 391, 426, 428,
    391, 428, 392, 392, 428, 430, 392, 430, 393, 393, 430, 432,
    393, 432, 394, 394, 432, 435, 394, 435, 395, 395, 435, 437,
    395, 437, 396, 396, 437, 439, 396, 439, 397, 397, 439, 441,
    397, 441, 398, 398, 441, 443, 398, 443, 399, 399, 443, 445,
    399, 445, 400, 400, 445, 447, 400, 447, 401, 401, 447, 449,
    401, 449, 402, 402, 449, 451, 402, 451, 403, 403, 451, 453,
    403, 453, 404, 404, 453, 455, 404, 455, 405, 405, 455, 457,
    405, 457, 406, 406, 457, 459, 406, 459, 407, 407, 459, 461,
    407, 461, 408, 408, 461, 463, 408, 463, 409, 409, 463, 465,
    409, 465, 410, 410, 465, 467, 410, 467, 411, 411, 467, 468,
    411, 468, 412, 412, 468, 470, 412, 470, 413, 413, 470, 414,
    413, 414, 381, 415, 472, 416, 415, 416, 383, 416, 473, 474,
    416, 474, 417, 386, 417, 475, 386, 475, 419, 419, 475, 476,
    419, 476, 421, 421, 476, 477, 421, 477, 423, 423, 477, 478,
    423, 478, 425, 425, 478, 479, 425, 479, 427, 427, 479, 480,
    427, 480, 429, 429, 480, 481, 429, 481, 431, 431, 481, 482,
    431, 482, 433, 433, 482, 483, 433, 483, 434, 434, 483, 484,
    434, 484, 436, 436, 484, 485, 436, 485, 438, 438, 485, 486,
    438, 486, 440, 440, 486, 487, 440, 487, 442, 442, 487, 488,
    442, 488, 444, 444, 488, 489, 444, 489, 446, 446, 489, 490,
    446, 490, 448, 448, 490, 491, 448, 491, 450, 450, 491, 492,
    450, 492, 452, 452, 492, 493, 452, 493, 454, 454, 493, 494,
    454, 494, 456, 456, 494, 495, 456, 495, 458, 458, 495, 496,
    458, 496, 460, 460, 496, 497, 460, 497, 462, 462, 497, 498,
    462, 498, 464, 464, 498, 499, 464, 499, 466, 466, 499, 500,
    466, 500, 469, 469, 500, 501, 469, 501, 471, 471, 501, 472,
    471, 472, 415, 472, 502, 473, 472, 473, 416, 473, 503, 504,
    473, 504, 474, 417, 474, 505, 417, 505, 475, 475, 505, 506,
    475, 506, 476, 476, 506, 507, 476, 507, 477, 477, 507, 508,
    477, 508, 478, 478, 508, 509, 478, 509, 479, 479, 509, 510,
    479, 510, 480, 480, 510, 511, 480, 511, 481, 481, 511, 512,
    481, 512, 482, 482, 512, 513, 482, 513, 483, 483, 513, 514,
    483, 514, 484, 484, 514, 515, 484, 515, 485, 485, 515, 516,
    485, 516, 486, 486, 516, 517, 486, 517, 487, 487, 517, 518,
    487, 518, 488, 488, 518, 519, 488, 519, 489, 489, 519, 520,
    489, 520, 490, 490, 520, 521, 490, 521, 491, 491, 521, 522,
    491, 522, 492, 492, 522, 523, 492, 523, 493, 493, 523, 524,
    493, 524, 494, 494, 524, 525, 494, 525, 495, 495, 525, 526,
    495, 526, 496, 496, 526, 527, 496, 527, 497, 497, 527, 528,
    497, 528, 498, 498, 528, 529, 498, 529, 499, 499, 529, 530,
    499, 530, 500, 500, 530, 531, 500, 531, 501, 501, 531, 502,
    501, 502, 472, 502, 532, 503, 502, 503, 473, 503, 533, 534,
    503, 534, 504, 474, 504, 535, 474, 535, 505, 505, 535, 536,
    505, 536, 506, 506, 536, 537, 506, 537, 507, 507, 537, 538,
    507, 538, 508, 508, 538, 539, 508, 539, 509, 509, 539, 540,
    509, 540, 510, 510, 540, 541, 510, 541, 511, 511, 541, 542,
    511, 542, 512, 512, 542, 543, 512, 543, 513, 513, 543, 544,
    513, 544, 514, 514, 544, 545, 514, 545, 515, 515, 545, 546,
    515, 546, 516, 516, 546, 547, 516, 547, 517, 517, 547, 548,
    517, 548, 518, 518, 548, 549, 518, 549, 519, 519, 549, 550,
    519, 550, 520, 520, 550, 551, 520, 551, 521, 521, 551, 552,
    521, 552, 522, 522, 552, 553, 522, 553, 523, 523, 553, 554,
    523, 554, 524, 524, 554, 555, 524, 555, 525, 525, 555, 556,
    525, 556, 526, 526, 556, 557, 526, 557, 527, 527, 557, 558,
    527, 558, 528, 528, 558, 559, 528, 559, 529, 529, 559, 560,
    529, 560, 530, 530, 560, 561, 530, 561, 531, 531, 561, 532,
    531, 532, 502, 532, 562, 533, 532, 533, 503, 533, 563, 564,
    533, 564, 534, 504, 534, 565, 504, 565, 535, 535, 565, 566,
    535, 566, 536, 536, 566, 567, 536, 567, 537, 537, 567, 568,
    537, 568, 538, 538, 568, 569, 538, 569, 539, 539, 569, 570,
    539, 570, 540, 540, 570, 571, 540, 571, 541, 541, 571, 572,
    541, 572, 542, 542, 572, 573, 542, 573, 543, 543, 573, 574,
    543, 574, 544, 544, 574, 575, 544, 575, 545, 545, 575, 576,
    545, 576, 546, 546, 576, 577, 546, 577, 547, 547, 577, 578,
    547, 578, 548, 548, 578, 579, 548, 579, 549, 549, 579, 580,
    549, 580, 550, 550, 580, 581, 550, 581, 551, 551, 581, 582,
    551, 582, 552, 552, 582, 583, 552, 583, 553, 553, 583, 584,
    553, 584, 554, 554, 584, 585, 554, 585, 555, 555, 585, 586,
    555, 586, 556, 556, 586, 587, 556, 587, 557, 557, 587, 588,
    557, 588, 558, 558, 588, 589, 558, 589, 559, 559, 589, 590,
    559, 590, 560, 560, 590, 591, 560, 591, 561, 561, 591, 562,
    561, 562, 532, 562, 592, 563, 562, 563, 533, 563, 593, 594,
    563, 594, 564, 534, 564, 595, 534, 595, 565, 565, 595, 596,
    565, 596, 566, 566, 596, 597, 566, 597, 567, 567, 597, 598,
    567, 598, 568, 568, 598, 599, 568, 599, 569, 569, 599, 600,
    569, 600, 570, 570, 600, 601, 570, 601, 571, 571, 601, 602,
    571, 602, 572, 572, 602, 603, 572, 603, 573, 573, 603, 604,
    573, 604, 574, 574, 604, 605, 574, 605, 575, 575, 605, 606,
    575, 606, 576, 576, 606, 607, 576, 607, 577, 577, 607, 608,
    577, 608, 578, 578, 608, 609, 578, 609, 579, 579, 609, 610,
    579, 610, 580, 580, 610, 611, 580, 611, 581, 581, 611, 612,
    581, 612, 582, 582, 612, 613, 582, 613, 583, 583, 613, 614,
    583, 614, 584, 584, 614, 615, 584, 615, 585, 585, 615, 616,
    585, 616, 586, 586, 616, 617, 586, 617, 587, 587, 617, 618,
    587, 618, 588, 588, 618, 619, 588, 619, 589, 589, 619, 620,
    589, 620, 590, 590, 620, 621, 590, 621, 591, 591, 621, 592,
    591, 592, 562, 592, 622, 593, 592, 593, 563, 593, 623, 624,
    593, 624, 594, 564, 594, 625, 564, 625, 595, 595, 625, 626,
    595, 626, 596, 596, 626, 627, 596, 627, 597, 597, 627, 628,
    597, 628, 598, 598, 628, 629, 598, 629, 599, 599, 629, 630,
    599, 630, 600, 600, 630, 631, 600, 631, 601, 601, 631, 632,
    601, 632, 602, 602, 632, 633, 602, 633, 603, 603, 633, 634,
    603, 634, 604, 604, 634, 635, 604, 635, 605, 605, 635, 636,
    605, 636, 606, 606, 636, 637, 606, 637, 607, 607, 637, 638,
    607, 638, 608, 608, 638, 639, 608, 639, 609, 609, 639, 640,
    609, 640, 610, 610, 640, 641, 610, 641, 611, 611, 641, 642,
    611, 642, 612, 612, 642, 643, 612, 643, 613, 613, 643, 644,
    613, 644, 614, 614, 644, 645, 614, 645, 615, 615, 645, 646,
    615, 646, 616, 616, 646, 647, 616, 647, 617, 617, 647, 648,
    617, 648, 618, 618, 648, 649, 618, 649, 619, 619, 649, 650,
    619, 650, 620, 620, 650, 651, 620, 651, 621, 621, 651, 622,
    621, 622, 592, 622, 652, 623, 622, 623, 593, 623, 653, 624,
    594, 624, 654, 594, 654, 625, 625, 654, 655, 625, 655, 626,
    626, 655, 656, 626, 656, 627, 627, 656, 657, 627, 657, 628,
    628, 657, 658, 628, 658, 629, 629, 658, 659, 629, 659, 630,
    630, 659, 660, 630, 660, 631, 631, 660, 661, 631, 661, 632,
    632, 661, 662, 632, 662, 633, 633, 662, 663, 633, 663, 634,
    634, 663, 664, 634, 664, 635, 635, 664, 665, 635, 665, 636,
    636, 665, 666, 636, 666, 637, 637, 666, 667, 637, 667, 638,
    638, 667, 668, 638, 668, 639, 639, 668, 669, 639, 669, 640,
    640, 669, 670, 640, 670, 641, 641, 670, 671, 641, 671, 642,
    642, 671, 672, 642, 672, 643, 643, 672, 673, 643, 673, 644,
    644, 673, 674, 644, 674, 645, 645, 674, 675, 645, 675, 646,
    646, 675, 676, 646, 676, 647, 647, 676, 677, 647, 677, 648,
    648, 677, 678, 648, 678, 649, 649, 678, 679, 649, 679, 650,
    650, 679, 680, 650, 680, 651, 651, 680, 652, 651, 652, 622,
    652, 653, 623, 624, 653, 654, 654, 653, 655, 655, 653, 656,
    656, 653, 657, 657, 653, 658, 658, 653, 659, 659, 653, 660,
    660, 653, 661, 661, 653, 662, 662, 653, 663, 663, 653, 664,
    664, 653, 665, 665, 653, 666, 666, 653, 667, 667, 653, 668,
    668, 653, 669, 669, 653, 670, 670, 653, 671, 671, 653, 672,
    672, 653, 673, 673, 653, 674, 674, 653, 675, 675, 653, 676,
    676, 653, 677, 677, 653, 678, 678, 653, 679, 679, 653, 680,
    680, 653, 652, 92, 89, 682, 92, 682, 684, 95, 91, 683,
    95, 683, 685, 88, 98, 688, 88, 688, 681, 97, 94, 686,
    97, 686, 687, 82, 79, 690, 82, 690, 692, 73, 81, 691,
    73, 691, 693, 78, 76, 694, 78, 694, 689, 76, 74, 693,
    76, 693, 694, 64, 62, 695, 64, 695, 697, 66, 63, 696,
    66, 696, 698, 60, 69, 700, 60, 700, 695, 69, 67, 699,
    69, 699, 700, 19, 27, 702, 19, 702, 704, 22, 21, 703,
    22, 703, 705, 26, 24, 706, 26, 706, 701, 24, 22, 705,
    24, 705, 706, 36, 34, 707, 36, 707, 708, 40, 37, 709,
    40, 709, 711, 34, 42, 712, 34, 712, 707, 42, 39, 710,
    42, 710, 712, 49, 46, 713, 49, 713, 715, 106, 50, 716,
    106, 716, 717, 47, 109, 718, 47, 718, 714, 109, 106, 717,
    109, 717, 718, 118, 114, 719, 118, 719, 721, 119, 117, 720,
    119, 720, 722, 114, 122, 724, 114, 724, 719, 122, 120, 723,
    122, 723, 724, 137, 134, 726, 137, 726, 728, 127, 136, 727,
    127, 727, 729, 133, 131, 732, 133, 732, 725, 130, 128, 730,
    130, 730, 731, 71, 58, 733, 71, 733, 734, 84, 71, 735,
    84, 735, 736, 125, 126, 129, 125, 129, 132, 58, 56, 740,
    58, 740, 733, 86, 84, 736, 86, 736, 739, 102, 100, 738,
    102, 738, 737, 105, 102, 737, 105, 737, 744, 755, 758, 745,
    755, 745, 754, 760, 755, 754, 760, 754, 753, 763, 760, 753,
    763, 753, 752, 765, 762, 751, 765, 751, 750, 767, 765, 750,
    767, 750, 749, 769, 767, 749, 769, 749, 748, 771, 769, 748,
    771, 748, 747, 773, 771, 747, 773, 747, 746, 757, 773, 746,
    757, 746, 745, 52, 105, 744, 52, 744, 743, 54, 52, 742,
    54, 742, 741, 56, 54, 741, 56, 741, 740, 100, 86, 739,
    100, 739, 738, 18, 30, 31, 31, 32, 33, 33, 35, 38,
    38, 29, 20, 20, 18, 31, 31, 33, 38, 31, 38, 20,
    28, 38, 41, 43, 35, 33, 28, 41, 43, 25, 28, 43,
    43, 33, 44, 44, 45, 48, 48, 51, 53, 53, 55, 57,
    59, 61, 65, 48, 53, 57, 57, 59, 65, 68, 77, 80,
    48, 57, 65, 43, 44, 48, 25, 43, 48, 25, 48, 65,
    18, 20, 23, 23, 25, 65, 17, 18, 23, 15, 16, 17,
    13, 14, 15, 11, 12, 13, 9, 10, 11, 93, 8, 9,
    87, 90, 93, 75, 72, 85, 85, 87, 93, 9, 11, 13,
    15, 17, 23, 15, 23, 65, 85, 93, 9, 83, 75, 85,
    80, 83, 85, 13, 15, 65, 13, 65, 68, 80, 85, 9,
    13, 68, 80, 80, 9, 13, 70, 61, 59, 72, 75, 77,
    70, 59, 72, 77, 68, 70, 72, 77, 70, 129, 126, 0,
    0, 3, 4, 4, 5, 6, 6, 7, 8, 8, 93, 96,
    99, 90, 87, 8, 96, 99, 0, 4, 6, 138, 129, 0,
    138, 0, 6, 6, 8, 99, 99, 87, 101, 101, 103, 104,
    104, 53, 51, 104, 51, 107, 104, 107, 108, 108, 48, 45,
    45, 110, 111, 111, 112, 113, 111, 113, 115, 108, 45, 111,
    101, 104, 108, 138, 6, 99, 101, 108, 111, 135, 138, 99,
    121, 125, 132, 135, 99, 101, 121, 132, 135, 111, 115, 116,
    116, 121, 135, 101, 111, 116, 101, 116, 135, 115, 113, 124,
    125, 121, 123, 123, 115, 124, 124, 125, 123,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05850061, 0.99821036, -0.01240013,
    0.05980062, 0.99821034, 0.00000000,
    0.07219804, 0.99727296, 0.01529958,
    -0.30898711, 0.86156407, -0.40278321,
    -0.30898711, 0.86156407, -0.40278321,
    -0.30899955, 0.86159876, -0.40269946,
    -0.65158222, -0.56418459, 0.50708614,
    -0.65158222, -0.56418459, 0.50708614,
    0.47630710, -0.59670890, 0.64580960,
    0.47630710, -0.59670890, 0.64580960,
    0.66888501, -0.56258740, -0.48588915,
    0.66888501, -0.56258740, -0.48588915,
    0.66888501, -0.56258740, -0.48588915,
    0.66882974, -0.56262505, -0.48592162,
    0.05460068, 0.99821253, 0.02430030,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.03510114, 0.99753247, 0.06080198,
    0.07139808, 0.93647483, -0.34339076,
    0.07139808, 0.93647483, -0.34339076,
    -0.81927656, -0.57078367, 0.05469843,
    -0.81927656, -0.57078367, 0.05469843,
    -0.81927656, -0.57078367, 0.05469843,
    0.02499892, -0.58897441, 0.80776494,
    0.02499892, -0.58897441, 0.80776494,
    0.02499892, -0.58897441, 0.80776494,
    0.77892591, -0.59731985, 0.19100635,
    0.77892591, -0.59731985, 0.19100635,
    0.01850016, 0.99820844, 0.05690048,
    0.00629979, 0.99816658, 0.06019798,
    -0.18230809, -0.96634289, -0.18150806,
    -0.18230809, -0.96634289, -0.18150806,
    -0.18230809, -0.96634289, -0.18150806,
    -0.43348921, 0.82097955, 0.37159074,
    -0.43348921, 0.82097955, 0.37159074,
    -0.43348921, 0.82097955, 0.37159074,
    -0.23240166, -0.91020654, -0.34280246,
    -0.23240166, -0.91020654, -0.34280246,
    -0.48730760, 0.58720915, -0.64631008,
    -0.48730760, 0.58720915, -0.64631008,
    -0.44150475, -0.59510636, -0.67150724,
    -0.44150475, -0.59510636, -0.67150724,
    -0.44601403, -0.89322808, 0.05670178,
    -0.44601403, -0.89322808, 0.05670178,
    0.05770277, 0.92214428, -0.38251838,
    0.05770277, 0.92214428, -0.38251838,
    0.05769745, 0.92215926, -0.38248307,
    -0.82110019, -0.56650016, 0.06980002,
    -0.82110019, -0.56650016, 0.06980002,
    -0.82110019, -0.56650016, 0.06980002,
    0.22510734, -0.56941860, 0.79062579,
    0.22510734, -0.56941860, 0.79062579,
    0.22508955, -0.56937358, 0.79066328,
    0.78559993, -0.61779993, -0.03400000,
    0.78555138, -0.61786177, -0.03399790,
    -0.24079935, -0.89549760, 0.37429898,
    -0.24079935, -0.89549760, 0.37429898,
    -0.18438903, 0.92054519, -0.34437950,
    -0.18439538, 0.92057688, -0.34429137,
    -0.18440601, 0.92052993, -0.34441118,
    -0.68112514, -0.58572160, 0.43931623,
    -0.68117876, -0.58568169, 0.43928630,
    0.57681535, -0.55431478, 0.60001598,
    0.57681535, -0.55431478, 0.60001598,
    0.57681535, -0.55431478, 0.60001598,
    0.60569083, -0.62339054, -0.49449252,
    0.60569083, -0.62339054, -0.49449252,
    0.60569083, -0.62339054, -0.49449252,
    0.31048932, -0.60197930, 0.73567472,
    0.31048932, -0.60197930, 0.73567472,
    0.83524724, 0.35852028, 0.41692356,
    0.83521240, 0.35850534, 0.41700619,
    -0.05540026, 0.94660450, -0.31760152,
    -0.05540026, 0.94660450, -0.31760152,
    -0.05540026, 0.94660450, -0.31760152,
    -0.78318224, -0.62178592, -0.00279994,
    -0.78318224, -0.62178592, -0.00279994,
    -0.78318224, -0.62178592, -0.00279994,
    -0.24049866, -0.57269681, 0.78369558,
    -0.24049866, -0.57269681, 0.78369558,
    -0.24049866, -0.57269681, 0.78369558,
    0.81910129, -0.56490088, 0.09980016,
    0.81910129, -0.56490088, 0.09980016,
    0.81909312, -0.56489522, 0.09989916,
    0.66938181, -0.56078478, -0.48728680,
    0.66938181, -0.56078478, -0.48728680,
    0.49320179, 0.58930212, -0.63990235,
    0.49320179, 0.58930212, -0.63990235,
    0.54169568, -0.60039523, -0.58829530,
    0.54162500, -0.60042772, -0.58832721,
    0.33940030, -0.57140054, 0.74720069,
    0.33940030, -0.57140054, 0.74720069,
    0.71577258, -0.57527800, -0.39588488,
    0.71572381, -0.57531917, -0.39591321,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04539985, 0.99769670, 0.05039983,
    -0.06909823, -0.94197595, -0.32849163,
    -0.06909823, -0.94197595, -0.32849163,
    -0.76903919, -0.58882997, 0.24871267,
    -0.76908004, -0.58878470, 0.24869353,
    -0.76908004, -0.58878470, 0.24869353,
    0.02530098, -0.59862323, 0.80063106,
    0.02530098, -0.59862323, 0.80063106,
    0.02529947, -0.59868738, 0.80058314,
    0.81939965, -0.56999977, 0.06069997,
    0.81939965, -0.56999977, 0.06069997,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.04399948, 0.99898827, 0.00929989,
    0.34989790, 0.89769454, -0.26779837,
    0.34989790, 0.89769454, -0.26779837,
    0.34989790, 0.89769454, -0.26779837,
    -0.46341171, -0.59901508, -0.65301648,
    -0.46341171, -0.59901508, -0.65301648,
    -0.46341171, -0.59901508, -0.65301648,
    -0.67842530, -0.56112092, 0.47421770,
    -0.67842530, -0.56112092, 0.47421770,
    -0.67847928, -0.56108287, 0.47418550,
    0.48470184, -0.59340226, 0.64260244,
    0.48470184, -0.59340226, 0.64260244,
    0.48470184, -0.59340226, 0.64260244,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43979830, 0.89809657, 0.00000000,
    -0.43019793, 0.89809568, -0.09139956,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15350420, 0.97332658, -0.17050465,
    0.18590659, 0.97323452, -0.13510480,
    0.20950767, 0.97333567, -0.09340342,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20969890, 0.97329487, 0.09339951,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399864, 0.97334492, 0.22808710,
    -0.02399864, 0.97334492, 0.22808710,
    -0.07099814, 0.97327447, 0.21839428,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43019793, 0.89809568, 0.09139956,
    -0.62761756, 0.77852180, 0.00000000,
    -0.61391052, 0.77851335, -0.13050224,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61391052, 0.77851335, 0.13050224,
    -0.78477526, 0.61978044, 0.00000000,
    -0.76738911, 0.62009120, -0.16309769,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76738911, 0.62009120, 0.16309769,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189677, 0.22129300, -0.96986930,
    0.30139453, 0.22079598, -0.92758314,
    0.48759211, 0.22119642, -0.84458633,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.30861232, 0.05600223, -0.94953788,
    0.30861232, 0.05600223, -0.94953788,
    0.49938821, 0.05579868, -0.86457962,
    0.49938821, 0.05579868, -0.86457962,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50012935, 0.00000000, -0.86595071,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.30861232, -0.05600223, -0.94953788,
    0.30861232, -0.05600223, -0.94953788,
    0.49938821, -0.05579868, -0.86457962,
    0.49938821, -0.05579868, -0.86457962,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30138787, -0.22089110, -0.92756265,
    0.48762444, -0.22091107, -0.84464235,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76738911, -0.62009120, -0.16309769,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76738911, -0.62009120, 0.16309769,
    -0.62761756, -0.77852180, 0.00000000,
    -0.61391052, -0.77851335, -0.13050224,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61391052, -0.77851335, 0.13050224,
    -0.43979830, -0.89809657, 0.00000000,
    -0.43019793, -0.89809568, -0.09139956,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.43019793, -0.89809568, 0.09139956,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15350420, -0.97332658, -0.17050465,
    0.18590659, -0.97323452, -0.13510480,
    0.20950767, -0.97333567, -0.09340342,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20969890, -0.97329487, 0.09339951,
    0.18590659, -0.97323452, 0.13510480,
    0.15369160, -0.97324685, 0.17079067,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399864, -0.97334492, 0.22808710,
    -0.02399864, -0.97334492, 0.22808710,
    -0.07099814, -0.97327447, 0.21839428,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04039896, -0.99817434, -0.04489885,
    0.04859973, -0.99819437, -0.03529980,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04859973, -0.99819437, 0.03529980,
    0.04019983, -0.99819579, 0.04459981,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630005, -0.99820839, 0.05950050,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01859991, -0.99819520, 0.05709973,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
    -0.14239852, 0.56199413, -0.81479155,
    -0.14239852, 0.56199413, -0.81479155,
    -0.78323074, 0.62172438, -0.00290011,
    -0.78323074, 0.62172438, -0.00290011,
    -0.24049866, 0.57269681, 0.78369558,
    -0.24049866, 0.57269681, 0.78369558,
    0.81909312, 0.56489522, 0.09989916,
    0.81909312, 0.56489522, 0.09989916,
    0.57681535, 0.55431478, 0.60001598,
    0.57681535, 0.55431478, 0.60001598,
    0.60569083, 0.62339054, -0.49449252,
    0.60569083, 0.62339054, -0.49449252,
    -0.39021475, 0.56262132, -0.72882762,
    -0.68112514, 0.58572160, 0.43931623,
    0.12290012, 0.56570054, -0.81540080,
    -0.82110019, 0.56650016, 0.06980002,
    -0.82110019, 0.56650016, 0.06980002,
    0.22510734, 0.56941860, 0.79062579,
    0.22510734, 0.56941860, 0.79062579,
    0.78559993, 0.61779993, -0.03400000,
    0.66888501, 0.56258740, -0.48588915,
    0.66888501, 0.56258740, -0.48588915,
    -0.49032243, 0.59242713, -0.63922923,
    -0.49032243, 0.59242713, -0.63922923,
    -0.65158222, 0.56418459, 0.50708614,
    0.47630710, 0.59670890, 0.64580960,
    0.16879626, 0.55888762, -0.81188204,
    -0.81927656, 0.57078367, 0.05469843,
    -0.81927656, 0.57078367, 0.05469843,
    0.02499892, 0.58897441, 0.80776494,
    0.02499892, 0.58897441, 0.80776494,
    0.77892591, 0.59731985, 0.19100635,
    -0.58963073, 0.55462892, -0.58713062,
    -0.58963073, 0.55462892, -0.58713062,
    -0.59449809, 0.62199800, 0.50959838,
    -0.59449809, 0.62199800, 0.50959838,
    0.33940030, 0.57140054, 0.74720069,
    0.71572381, 0.57531917, -0.39591321,
    -0.17069750, 0.55859184, -0.81168807,
    -0.76908004, 0.58878470, 0.24869353,
    -0.76908004, 0.58878470, 0.24869353,
    0.02530098, 0.59862323, 0.80063106,
    0.02530098, 0.59862323, 0.80063106,
    0.81939965, 0.56999977, 0.06069997,
    -0.67842530, 0.56112092, 0.47421770,
    -0.67842530, 0.56112092, 0.47421770,
    0.48470184, 0.59340226, 0.64260244,
    0.48470184, 0.59340226, 0.64260244,
    0.65606189, 0.56356728, -0.50197083,
    0.65606189, 0.56356728, -0.50197083,
    -0.46341171, 0.59901508, -0.65301648,
    -0.46341171, 0.59901508, -0.65301648,
    -0.78143034, 0.61602394, 0.09940386,
    -0.41987661, 0.63076486, 0.65256365,
    -0.41990401, 0.63080606, 0.65250620,
    0.31048932, 0.60197930, 0.73567472,
    0.49320179, -0.58930212, -0.63990235,
    0.66938181, 0.56078478, -0.48728680,
    0.65633033, 0.67963139, 0.32761513,
    -0.44150475, 0.59510636, -0.67150724,
    -0.48730760, -0.58720915, -0.64631008,
    -0.45649533, 0.58139404, -0.67349312,
    -0.45652608, 0.58143321, -0.67343846,
    0.59250425, 0.48460348, -0.64350461,
    -0.01570058, -0.96523556, 0.26090958,
    0.58250542, 0.68420638, 0.43880413,
    0.27421433, 0.61903240, 0.73593844,
    0.73511765, -0.54691313, 0.40060963,
    0.45951351, -0.65821938, -0.59631752,
    -0.18529553, -0.59248569, -0.78398104,
    -0.74915390, -0.54876624, 0.37097716,
    -0.74919500, -0.54869635, 0.37099753,
    -0.59139533, 0.57189550, 0.56849547,
    -0.74347981, -0.65598222, 0.13009647,
    -0.74347981, 0.65598222, 0.13009647,
    -0.74347981, 0.65598222, 0.13009647,
    -0.04999766, 0.55197409, 0.83236100,
    -0.05000041, 0.55190460, 0.83240691,
    -0.05000041, 0.55190460, 0.83240691,
    -0.59139533, -0.57189550, 0.56849547,
    -0.59139533, -0.57189550, 0.56849547,
    -0.74915390, 0.54876624, 0.37097716,
    -0.74919500, 0.54869635, 0.37099753,
    -0.74919500, 0.54869635, 0.37099753,
    -0.18529553, 0.59248569, -0.78398104,
    -0.18529553, 0.59248569, -0.78398104,
    0.45951351, 0.65821938, -0.59631752,
    0.45951351, 0.65821938, -0.59631752,
    0.73511765, 0.54691313, 0.40060963,
    0.73508821, 0.54689120, 0.40069358,
    0.27421433, -0.61903240, 0.73593844,
    0.27419415, -0.61898679, 0.73598433,
    0.58250542, -0.68420638, 0.43880413,
    0.58250542, -0.68420638, 0.43880413,
  ]),
  materialIndex: 0,
};

const BODY_MESH_1: RuneMesh = {
  name: "Body_Rune_primitive1",
  positions: new Float32Array([
    -0.34909999, 0.35019997, -0.34360003,
    -0.30500001, 0.35019997, -0.43530002,
    -0.39330000, 0.35019994, -0.62210000,
    -0.54269999, 0.35019997, -0.53380001,
    -0.07740000, 0.35019994, -0.72740000,
    -0.02640000, 0.35019997, -0.52700001,
    0.07890000, 0.35019997, -0.47610003,
    0.10610000, 0.35019994, -0.67309999,
    0.39140001, 0.35019997, -0.31300002,
    0.57819998, 0.35019997, -0.48970002,
    0.43550000, 0.35019997, -0.58480000,
    0.34720001, 0.35019997, -0.39120004,
    0.43889999, 0.35020000, 0.06739997,
    0.68349999, 0.35020000, 0.06739997,
    0.72090000, 0.35020000, -0.07190003,
    0.48310000, 0.35020000, -0.06850003,
    0.39140001, 0.35020003, 0.58370000,
    0.53410000, 0.35020003, 0.44109997,
    0.34720001, 0.35020003, 0.29839998,
    0.29629999, 0.35020003, 0.34259996,
    0.07890000, 0.35020006, 0.72979999,
    0.02450000, 0.35020003, 0.52939999,
    -0.06720000, 0.35020003, 0.48859996,
    -0.12490000, 0.35020006, 0.67540002,
    -0.43740001, 0.35020003, 0.54299998,
    -0.34230000, 0.35020003, 0.29839998,
    -0.40009999, 0.35020003, 0.26099998,
    -0.58350003, 0.35020003, 0.39689997,
    -0.43740001, 0.35020000, -0.11940003,
    -0.68879998, 0.35020000, -0.11940003,
    -0.72960001, 0.35020000, 0.02329997,
    -0.48840001, 0.35020000, 0.01989997,
  ]),
  indices: new Uint16Array([
    1, 0, 3, 1, 3, 2, 5, 4, 7, 5, 7, 6,
    9, 8, 11, 9, 11, 10, 13, 12, 15, 13, 15, 14,
    17, 16, 19, 17, 19, 18, 21, 20, 23, 21, 23, 22,
    25, 24, 27, 25, 27, 26, 29, 28, 31, 29, 31, 30,
  ]),
  normals: new Float32Array([
    -0.14239852, 0.56199413, -0.81479155,
    -0.78323074, 0.62172438, -0.00290011,
    -0.24049866, 0.57269681, 0.78369558,
    0.81909312, 0.56489522, 0.09989916,
    0.57681535, 0.55431478, 0.60001598,
    0.60569083, 0.62339054, -0.49449252,
    -0.39021475, 0.56262132, -0.72882762,
    -0.68112514, 0.58572160, 0.43931623,
    0.12290012, 0.56570054, -0.81540080,
    -0.82110019, 0.56650016, 0.06980002,
    0.22510734, 0.56941860, 0.79062579,
    0.78559993, 0.61779993, -0.03400000,
    0.66888501, 0.56258740, -0.48588915,
    -0.49032243, 0.59242713, -0.63922923,
    -0.65158222, 0.56418459, 0.50708614,
    0.47630710, 0.59670890, 0.64580960,
    0.16879626, 0.55888762, -0.81188204,
    -0.81927656, 0.57078367, 0.05469843,
    0.02499892, 0.58897441, 0.80776494,
    0.77892591, 0.59731985, 0.19100635,
    -0.58963073, 0.55462892, -0.58713062,
    -0.59449809, 0.62199800, 0.50959838,
    0.33940030, 0.57140054, 0.74720069,
    0.71572381, 0.57531917, -0.39591321,
    -0.17069750, 0.55859184, -0.81168807,
    -0.76908004, 0.58878470, 0.24869353,
    0.02530098, 0.59862323, 0.80063106,
    0.81939965, 0.56999977, 0.06069997,
    -0.67842530, 0.56112092, 0.47421770,
    0.48470184, 0.59340226, 0.64260244,
    0.65606189, 0.56356728, -0.50197083,
    -0.46341171, 0.59901508, -0.65301648,
  ]),
  materialIndex: 1,
};

const BODY_MESH_2: RuneMesh = {
  name: "Body_Rune_primitive2",
  positions: new Float32Array([
    0.39660001, 0.35020000, -0.06720003,
    0.16900000, 0.35019997, -0.39330003,
    -0.12650000, 0.35019997, -0.44760004,
    -0.25220001, 0.35020000, 0.02449997,
    -0.39829999, 0.35020000, 0.02789997,
    -0.34729999, 0.35020000, -0.11810003,
    0.34220001, 0.35020000, 0.07889997,
    0.20980000, 0.35020000, 0.07209997,
    0.12480000, 0.35020003, 0.43889996,
    -0.16390000, 0.35020003, 0.39479998,
    -0.03140000, 0.35020003, 0.30989996,
    0.11130000, 0.35020000, 0.07209997,
    0.20640001, 0.35020000, -0.02980003,
    0.30149999, 0.35020000, -0.01960003,
    0.07390000, 0.35019997, -0.30160004,
    -0.02460000, 0.35019997, -0.34570003,
    -0.25220001, 0.35020000, -0.06720003,
    -0.15369999, 0.35020000, -0.07060003,
    -0.16050000, 0.35020000, 0.02109997,
  ]),
  indices: new Uint16Array([
    10, 11, 12, 13, 1, 0, 10, 12, 13, 8, 9, 10,
    0, 6, 7, 7, 8, 10, 13, 0, 7, 13, 7, 10,
    18, 10, 9, 3, 4, 5, 18, 9, 3, 16, 17, 18,
    16, 18, 3, 1, 13, 14, 1, 14, 15, 16, 3, 5,
    2, 1, 15, 15, 16, 5, 5, 2, 15,
  ]),
  normals: new Float32Array([
    -0.78143034, 0.61602394, 0.09940386,
    -0.41987661, 0.63076486, 0.65256365,
    0.31048932, 0.60197930, 0.73567472,
    0.49320179, -0.58930212, -0.63990235,
    0.66938181, 0.56078478, -0.48728680,
    0.65633033, 0.67963139, 0.32761513,
    -0.44150475, 0.59510636, -0.67150724,
    -0.48730760, -0.58720915, -0.64631008,
    -0.45649533, 0.58139404, -0.67349312,
    0.59250425, 0.48460348, -0.64350461,
    -0.01570017, -0.96521036, 0.26100280,
    0.58250542, 0.68420638, 0.43880413,
    0.27421433, 0.61903240, 0.73593844,
    0.73511765, -0.54691313, 0.40060963,
    0.45948329, -0.65827601, -0.59627830,
    -0.18530650, -0.59242080, -0.78402749,
    -0.74915390, -0.54876624, 0.37097716,
    -0.59139533, 0.57189550, 0.56849547,
    -0.74347981, -0.65598222, 0.13009647,
  ]),
  materialIndex: 2,
};

export const BODY_MESHES: RuneMesh[] = [
  BODY_MESH_0,
  BODY_MESH_1,
  BODY_MESH_2,
];
